import {
    MoveLeft,
    Plus,
} from "lucide-react";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";

export type HeaderProps = {
    title: string;
}

export const Header = ({title}: HeaderProps)=> {
    const navigate = useNavigate();
    return (
        <div className="settings-element-header">
            <MoveLeft
                onClick={() => navigate("/app/settings")}
                className={styles["back-button"]}
            />

            <p className={`settings-element-title page-title`}>{title}</p>

            <div></div>
            <Plus className={styles["hidden-plus-button"]} />
        </div>
    );
}

export default Header;